module.exports = __webpack_public_path__ + "static/media/partner_zhongguoguangdayinhang.bea5c08b.png";